import React, { useEffect, useState } from "react";
import { Grid, Container, Typography, Slide } from "@material-ui/core";
import { useEventData } from "../../../utils/event-data";
import { makeStyles } from "@material-ui/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../assets/slider.css";
import BackgroundImage from "gatsby-background-image";
import Img from "gatsby-image";
import { Link } from "gatsby";

const useStyles = makeStyles({
  countryContainer: {
    height: 80,
  },
  eventContainer: {
    width: "100%",
    borderRadius: 10,
    boxShadow: "0 3px 15px rgba(57, 63, 72, 0.1)",
    height: "auto",
    minHeight: "80px",
    marginBottom: 15,
    maxWidth: 450,
    transform: "scale(0.98)",
  },
});

const getDate = (start, end) => {
  let dateString = "";
  const startDate = new Date(start * 1000);
  const endDate = new Date(end * 1000);

  if (start === end) {
    dateString = startDate.toDateString();
  } else {
    dateString = startDate.toDateString() + " - " + endDate.toDateString();
  }

  return dateString;
};

const settings2 = {
  infinite: true,
  speed: 5000,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  slidesToScroll: 1,
  initialSlide: 0,
  lazyLoad: "progressive",
  dots: false,
  className: "slider",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const SearchDrawer = (props) => {
  const data = useEventData();
  const classes = useStyles();
  const [featured, setFeatured] = useState([]);
  const [countries, setCountries] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const countryContainerStyle = [
    { background: "white" },
    { background: "white" },
  ];

  useEffect(() => {
    const newFeatured = data.allWpEvent.edges.filter(
      (event) => event.node.isFeatured === "yes"
    );
    setFeatured(newFeatured);
  }, []);

  useEffect(() => {
    if (props.searchQuery.length >= 3) {
      const newSearchQuery = data.allWpEvent.edges.filter(
        (event) =>
          event.node.locationName
            .toLowerCase()
            .includes(props.searchQuery.toLowerCase()) ||
          event.node.title
            .toLowerCase()
            .includes(props.searchQuery.toLowerCase())
      );
      setSearchQuery(newSearchQuery);
    } else {
      setSearchQuery([]);
    }
  }, [props.searchQuery]);

  return (
    <Slide in={true} direction="up" mountOnEnter unmountOnExit>
      <div
        style={{
          padding: "20px",
          maxWidth: 1080,
          minHeight: 400,
          margin: "auto",
          background: "rgb(250,250,250)",
          borderRadius: "0px 0px 10px 10px",
          zIndex: 9999,
        }}
      >
        <Typography
          variant={"h4"}
          style={{ marginBottom: 5, marginTop: 10, fontWeight: 700 }}
        >
          Our Favourites
        </Typography>
        <Slider {...settings2}>
          {featured.map((event) => {
            return (
              <Link
                to={`/event/${event.node.eventLocations.nodes[0].slug}`}
                key={event.node.id}
              >
                <div
                  style={{
                    height: 160,
                    width: "100%",
                  }}
                >
                  <BackgroundImage
                    fluid={
                      event.node.featuredImage.node.localFile.childImageSharp
                        .fluid
                    }
                    style={{
                      height: 160,
                      width: "100%",
                      overflow: "hidden",
                      borderRadius: 8,
                    }}
                    Tag="div"
                  >
                    <div
                      style={{
                        color: "white",
                        width: "100%",
                        height: "160px",
                        backgroundColor: "rgba(0,0,0,0.3)",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="h5" style={{ fontWeight: 600 }}>
                        {event.node.title}
                      </Typography>
                      <Typography variant="h6" style={{ fontWeight: 600 }}>
                        {getDate(event.node.eventStart, event.node.eventEnd)}
                      </Typography>
                    </div>
                  </BackgroundImage>
                </div>
              </Link>
            );
          })}
        </Slider>
        <Typography
          variant={"h4"}
          style={{ marginBottom: 15, fontWeight: 700, marginTop: 20 }}
        >
          Your search results
        </Typography>
        <Grid container>
          {searchQuery.length > 0 ? (
            searchQuery.map((event) => {
              return (
                <Link
                  to={`/event/${event.node.eventLocations.nodes[0].slug}`}
                  key={event.node.id}
                >
                  <Grid
                    key={event.node.id}
                    className={classes.eventContainer}
                    container
                    item
                  >
                    <Grid item>
                      <Img
                        fluid={
                          event.node.featuredImage.node.localFile
                            .childImageSharp.fluid
                        }
                        style={{
                          width: "90px",
                          height: "100%",
                          overflow: "hidden",
                          display: "inline-block",
                          borderRadius: "10px 0px 0px 10px",
                          marginRight: 20,
                        }}
                        imgStyle={{
                          objectFit: "cover",
                        }}
                      ></Img>
                    </Grid>
                    <Grid item xs={7}>
                      <Grid item>
                        <Typography
                          varian="h6"
                          style={{ marginTop: 18, fontWeight: 700 }}
                        >
                          {event.node.title}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography
                          varian="body1"
                          style={{
                            marginTop: 0,
                            marginBottom: 18,
                            fontWeight: 400,
                          }}
                        >
                          When:{" "}
                          {getDate(event.node.eventStart, event.node.eventEnd)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Link>
              );
            })
          ) : (
            <Typography variant={"body1"}>
              {props.searchQuery.length < 3 ? (
                <span>Search query is not long enough</span>
              ) : (
                <span>
                  No events found, please try again or use our calendar
                </span>
              )}
            </Typography>
          )}
        </Grid>
      </div>
    </Slide>
  );
};
export default SearchDrawer;
